import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarDurationMilliseconds } from '../util/constant';
import { ErrorAlertComponent } from '../auth/components/error-snackbar/error-alert.component';
import { SuccessAlertComponent } from '../auth/components/success-snackbar/success-alert.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackbar = inject(MatSnackBar);
  private showingMessage = false;

  error(message: string) {
    setTimeout(() => {
      this.snackbar.openFromComponent(ErrorAlertComponent, {
        duration: SnackbarDurationMilliseconds,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        data: message,
      });
    });
  }

  success(message: string) {
    setTimeout(() => {
      this.snackbar.openFromComponent(SuccessAlertComponent, {
        duration: SnackbarDurationMilliseconds,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        data: message,
      });
    });
  }

  isShowingMessage(): boolean {
    return this.showingMessage;
  }
}
